import { Query } from '@tanstack/react-query';

import { TAiPageChatMessageDto } from '@app-velocity/av-api-v2';

export const getDiscussionRefetchInterval = (
  query: Query<TAiPageChatMessageDto[] | undefined, Error>
): number | false => {
  const currentMessages = query.state.data;
  if (!currentMessages?.length) return false;
  const lastMessage = currentMessages[currentMessages.length - 1];

  return lastMessage?.messageType === 'USER' ? 2000 : false;
};
